const centerCardList = [
    {
        id: 2,
        imageUrl: `https://img.positivehotel.io/2023/12/8/PHB09250.jpg`,
        title: '도산 클럽하우스',
        content: '요가・푸드・티 테라피까지 내 몸과 마음에 맞는 루틴을\n직접 탐색하며 나만의 웰니스를 찾아가는 공간',
        to: "/yoga-center/2"
    },
    {
        id: 3,
        imageUrl: `https://img.positivehotel.io/2024/7/11/seolleung-02.jpg`,
        title: '선릉',
        content: '지중해식 기반 웰니스 키친과 150평 규모의\n요가 스튜디오가 결합된 도심 속 웰니스 공간',
        to: "/yoga-center/3"
    },
]

const programCardList = [
    {
        id: 1,
        title: 'MINDFULNESS RETREAT PROGRAM',
        content: '바쁜 일상에서 벗어나, 감각을 깨우고 내면의 진정한 나를 만나는 프로그램',
        imgUrl: 'https://img.positivehotel.io/2025/5/8/home-brand-program-0-2.png',
        to: '/wellness-program/2'
    },
    {
        id: 2,
        title: 'ENERGY RETREAT PROGRAM',
        content: '활력을 충전하고 몸과 마음의 에너지를 되찾을 수 있는 프로그램',
        imgUrl: 'https://img.positivehotel.io/2025/5/8/home-brand-program-1-3.png',
        to: '/wellness-program/3'
    },
    {
        id: 3,
        title: 'RECOVERY RETREAT PROGRAM',
        content: '지친 몸과 마음을 정화하고, 온전한 회복을 위한 시간을 선물하는 프로그램',
        imgUrl: 'https://img.positivehotel.io/2025/5/8/home-brand-program-2-4.png',
        to: '/wellness-program/4'
    }
]

export interface ICenterCard {
    imageUrl: string
    title: React.ReactNode
    content: React.ReactNode
    to: string
}

export { centerCardList, programCardList }